import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { RichTextViewer as QuillRichTextViewer, Card, Column } from 'seagull';
import '~/components/AgreementStudioPage/TemplateVariables/TemplateVariableBlot/TemplateVariableBlot';
import { Calendar, DollarCircle, Invoice, InvoiceEdit, Note, UserCheck } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useCobConfig } from '~/client-flow/clientOb/CobConfigContext';
import styles from './AdditionalTerms.module.scss';
import { getAdditionalTermsData } from './additionalTerms.utils';
import { TermItem } from './TermItem';
export const GetAdditionalTermsTID = ()=>getTestIds();
const iconMap = {
    effectiveDate: /*#__PURE__*/ _jsx(Calendar, {}),
    paymentTerms: /*#__PURE__*/ _jsx(DollarCircle, {}),
    amendments: /*#__PURE__*/ _jsx(InvoiceEdit, {}),
    outOfScopeCharges: /*#__PURE__*/ _jsx(Invoice, {}),
    accountantAccess: /*#__PURE__*/ _jsx(UserCheck, {}),
    agreementNotes: /*#__PURE__*/ _jsx(Note, {})
};
const testIdMap = {
    effectiveDate: ()=>GetAdditionalTermsTID().AdditionalTermsTestIds.EffectiveDate(),
    paymentTerms: ()=>GetAdditionalTermsTID().AdditionalTermsTestIds.PaymentTerms(),
    amendments: ()=>GetAdditionalTermsTID().AdditionalTermsTestIds.Amendments(),
    outOfScopeCharges: ()=>GetAdditionalTermsTID().AdditionalTermsTestIds.OutOfScopeCharges(),
    accountantAccess: ()=>GetAdditionalTermsTID().AdditionalTermsTestIds.AccountantAccess(),
    agreementNotes: ()=>GetAdditionalTermsTID().AdditionalTermsTestIds.AgreementNotes()
};
export const AdditionalTerms = ()=>{
    const { relationship } = useCobConfig();
    const { AdditionalTermsTestIds } = useMemo(()=>GetAdditionalTermsTID(), []);
    const termItems = useMemo(()=>getAdditionalTermsData(relationship).map((item)=>({
                icon: iconMap[item.key],
                title: item.title,
                description: item.key === 'agreementNotes' ? /*#__PURE__*/ _jsx(QuillRichTextViewer, {
                    className: styles.richTextNote,
                    testId: "extra-clause-rich-text-viewer",
                    value: item.description
                }) : item.description,
                testId: testIdMap[item.key]()
            })), [
        relationship
    ]);
    return /*#__PURE__*/ _jsx(Card, {
        className: styles.card,
        testId: AdditionalTermsTestIds.Card(),
        children: /*#__PURE__*/ _jsx(Column, {
            gap: 20,
            children: termItems.map((item, idx)=>/*#__PURE__*/ _jsx(TermItem, {
                    icon: item.icon,
                    title: item.title,
                    description: item.description,
                    testId: item.testId
                }, idx))
        })
    });
};
